export default __webpack_public_path__ + "static/media/invoice_4.54a71392.jpg";